import Model from '../../ModelBinding/Model';
import AgessaRateCollection from './AgessaRateCollection';

export default class AgessaRate extends Model {
  public code?: string;
  public contribution?: string;
  public group?: string;
  public base?: number;
  public rate?: number;
  public value?: number;
  public year?: number;

  bind() {
    this.code = this.getStringAttribute('code');
    this.contribution = this.getStringAttribute('contribution');
    this.group = this.getStringAttribute('group');
    this.base = this.getIntAttribute('base');
    this.rate = this.getFloatAttribute('rate');
    this.value = this.getIntAttribute('value');
    this.year = this.getIntAttribute('year');
  }

  static getCollection() {
    return AgessaRateCollection;
  }
}
